var React = require('react');

function IconLanguageCircle (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"30","width":"120","height":"120","rx":"60","fill":"#1D46E3","key":0}),React.createElement("path",{"d":"M90 0C123.137 0 150 26.8629 150 60C150 93.1371 123.137 120 90 120V0Z","fill":"#0B1C63","key":1})]);
}

IconLanguageCircle.defaultProps = {"width":"180","height":"120","viewBox":"0 0 180 120","fill":"none"};

module.exports = IconLanguageCircle;

IconLanguageCircle.default = IconLanguageCircle;
